import PropTypes from 'prop-types';

import AvatarPlaceholderImage from 'shared/assets/avatar-placeholder.svg';

export const PIXELS_IN_1_REM = 16;
export const DEFAULT_IMAGE_SRC = '/image-placeholder.svg';

export const IMAGE_TYPES = {
  AVATAR: 'avatar',
};

export const IMAGE_PLACEHOLDERS = {
  [IMAGE_TYPES.AVATAR]: AvatarPlaceholderImage,
};

export const ImagePropTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  borderRadius: PropTypes.number,
  type: PropTypes.oneOf(Object.values(IMAGE_TYPES)),
};
